import { Injectable, inject } from "@angular/core";
import { LorenImageSize } from "./enums/loren-image-size.enum";
import { LorenImage } from "./interfaces/loren-image.interface";
import { LorenImageEndpointsService } from "../loren-image-endpoints-service/loren-image-endpoints.service";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { LorenImageConstants } from "./constants/loren-image.constants";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class LorenImageService {
  private http = inject(HttpClient);
  private endpointsService = inject(LorenImageEndpointsService);

  private assetsImageCache: Map<string, LorenImage> = new Map<
    string,
    LorenImage
  >();

  get(guid: string, size: LorenImageSize): Observable<LorenImage> {
    if (!guid) {
      return of({ content: LorenImageConstants.defaultImage });
    }

    if (this.assetsImageCache.has(guid)) {
      return of(this.assetsImageCache.get(guid));
    } else {
      return this.http
        .get<LorenImage>(this.endpointsService.getImage(guid, size), {})
        .pipe(
          tap((res) => {
            this.assetsImageCache.set(guid, res);
          })
        );
    }
  }

  clearAllImagesCache() {
    this.assetsImageCache.clear();
  }
}
